import { render } from "./BlockUI.vue?vue&type=template&id=2edde949"
import script from "./BlockUI.vue?vue&type=script&lang=js"
export * from "./BlockUI.vue?vue&type=script&lang=js"

import "./BlockUI.vue?vue&type=style&index=0&id=2edde949&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__